module.exports = __webpack_public_path__ + "assets/img/page-background.2a2790ee.png";